<template>
  <div>
    <div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-11">
            <h4>Información de las evoluciones sin logro de objetivo</h4>
            <p>
              Aquí podrá gestionar la información relacionada con los
              <span class="text-success"
                >Informes entregados a los pacientes</span
              >
              de <span class="text-success">Avanza</span> por fecha
            </p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <form
          @submit.prevent="
            obtenerInformacionDeEvoluciones(fechaInicial, fechaFinal)
          "
        >
          <div class="col-md-3">
            <label for="">Paciente:</label>
            <select v-model="paciente" class="form-control">
              <option value="">Seleccionar paciente....</option>
              <option
                :value="paciente.PacIdeUsu"
                v-for="paciente in pacienteSelect"
                :key="paciente.PacIdeUsu"
              >
                {{ paciente.PacNom1 + " " + paciente.PacApe1 }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label for="fechaInicial">Fecha inicial:</label>
            <input
              type="date"
              v-model="fechaInicial"
              required
              id="fechaInicial"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <label for="fechaInicial">Fecha final:</label>
            <input
              type="date"
              v-model="fechaFinal"
              required
              id="fechaInicial"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <br />
            <input
              type="submit"
              value="Buscar información"
              class="btn btn-success btn-fill"
            />
          </div>
        </form>
      </div>
      <div class="card" style="margin-top: 15px">
        <div class="row">
          <center>
            <div class="col-md-12" v-if="queriedData2 == ''">
              <center>
                <img
                  src="/static/img/ICONOS/estadisticas.svg"
                  alt="Imagen de datos vacios"
                  width="70"
                />
                <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
              </center>
            </div>
          </center>
        </div>

        <div class="row" style="padding-left: 15px" v-if="queriedData2 != ''">
          <br />
          <br />
          <div class="col-3">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <br />
            <br />
          </div>
        </div>

        <div class="row" ref="component" v-if="queriedData2 != ''">
          <!-- <div class="col-md-12">
            <download-excel
              class="btn btn-secondary btn-fill mb-2"
              :data="json_data"
              :fields="json_fields"
              worksheet="evoluciones sin logro de objetivo"
              :name="`Evoluciones sin logro - ${fechaInicial} -- ${fechaFinal}`"
              v-if="json_data != ''"
            >
              Exportar a excel <i color="black" class="fa fa-download"></i>
            </download-excel>
            <br />
          </div> -->
          <div class="col-md-12">
            <br />
            <el-table border :data="queriedData" class="table-responsive mt-2">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
                <template slot-scope="{ row }">
                  <span>{{ row[column.prop] }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="row" v-if="queriedData2 != ''">
          <div class="col-sm-6 pagination-info">
            <br />
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import axiosInstance from "src/global-services/axiosInstance";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
import crearAlerta from "../../global-services/crearAlerta";
import formatearPesosColombianos from "../../global-services/formatear-pesos";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },
  data: () => ({
    paciente: "",
    ip: "https://avanti-erp.com/",
    pacienteSelect: [],
    searchQuery: "",
    fechaInicial: "",
    fechaFinal: "",
    listUsers: [],
    arrayEps: [],
    categoria: "Todas",
    queriedData2: [],
    form: {
      fecha: "",
      monto: "",
      categoria: "Prestamo",
      comentario: "",
      usuario: "",
      eps: "",
      tipo: "",
    },
    fechaActual: "",
    tableColumns: [
      {
        prop: "entrega",
        label: "Usuario que entrega",
        minWidth: 100,
      },
      {
        prop: "tipo",
        label: "Tipo de informe",
        minWidth: 100,
      },
      {
        prop: "creado",
        label: "Fecha y hora de exportación",
        minWidth: 100,
      },
      {
        prop: "resumen",
        label: "Resumen",
        minWidth: 100,
      },
      {
        prop: "concepto",
        label: "Concepto",
        minWidth: 100,
      },
      {
        prop: "recomendacion",
        label: "Recomendaciones",
        minWidth: 100,
      },
      
    ],
    json_fields: {
      paciente: "nombrePaciente",
      terapeuta: "terapeuta",
      fecha: "fecha",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    SedesProgramacion: [],
    sede: "Sede Principal",
    rol: "",
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
  }),
  components: {
    PPagination,
  },
  methods: {
    formatearPesosColombianos,
    prepararRegistrar: function () {
      this.$modal.show("registrar-gasto");
    },
    async obtenerInformacionDeEvoluciones(fechaInicial, fechaFinal) {
      try {
        this.$modal.show("carga");
        const sede = localStorage.getItem("sede");
        const response = await axiosInstance.get(
          `api/obtener-log-informe/${this.paciente}/${fechaInicial}/${fechaFinal}`
        );
        this.queriedData2 = response.data.data;
        this.json_data = response.data.data;
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    getClass(column, row) {
      if (column.prop === "valor") {
        if (row.tipo === "Efectivo") {
          return "low-percentage";
        }

        if (row.tipo === "Transferencia") {
          return "medium-percentage";
        }
      }
      return "";
    },
    getInformacion() {
      const BASE_URL = `${this.ip}api/pacientesSelect`;
      axios
        .get(BASE_URL)
        .then((res) => {
          this.pacienteSelect = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getInformacion();
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de evoluciones sin logro de objetivo";
  },
};
</script>
        
  <style>
.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.btn {
  border-radius: 5px;
}

.high-percentage {
  background-color: #a0e2b3;
  /* color: white !important; */
}

.medium-percentage {
  background-color: #f2e3b0;
  /* color: black; */
}

.info-percentage {
  background-color: #5f8afe;
  /* color: black; */
}

.low-percentage {
  background-color: #fb817e;
  /* color: white; */
}

.full-width {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  /* padding: 15px; Si quieres mantener el padding interno */
}

table {
  width: 50%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  border: none;
}
th,
td {
  border: none;
  padding: 0px;
  text-align: left;
}
th {
  background-color: #f2f2f2;
}
.color-box {
  width: 5px;
  height: 5px;
  display: inline-block;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Reportes/logInformes.vue